"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "36", height: "39", viewBox: "0 0 36 39", className: "Icon element-column", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement("path", { id: "b-element-column", d: "M1 1h34v36H1z" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-element-column" },
                _react2.default.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
                _react2.default.createElement("feGaussianBlur", { stdDeviation: ".5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0 0.443137255 0 0 0 0.329313859 0", "in": "shadowBlurOuter1" })
            )
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "#000", filter: "url(#a-element-column)", xlinkHref: "#b-element-column" }),
                _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#b-element-column" })
            ),
            _react2.default.createElement("path", { d: "M36 0v38H0V0h36zM1 1v36h34V1H1z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { d: "M32 11v10H4V11h28zM5 12v8h26v-8H5z", fill: "#C6C6C6" }),
            _react2.default.createElement("path", { fill: "#333", d: "M10 5h16v2H10z" }),
            _react2.default.createElement("path", { d: "M32 23v10H4V23h28zM5 24v8h26v-8H5z", fill: "#C6C6C6" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/element-column.js
// module id = 1795
// module chunks = 0